import MemoryAllocationInput from './MemoryAllocationInput';

export default MemoryAllocationInput;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/MemoryAllocationInput/index.js